import React from 'react'
import PropTypes from 'prop-types'
import { Colours, Sizes } from '../../style_helpers'

const LocationIcon = (props) => {
  return (
    <svg height={props.height} style={props.style} viewBox='0 0 19 22' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'>
      <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd' transform='translate(-853.000000, -622.000000)' strokeLinecap='round' strokeLinejoin='round'>
        <g transform='translate(730.000000, 299.000000)' stroke={props.colour} strokeWidth={props.lineWeight}>
          <g transform='translate(125.000000, 325.000000)'>
            <path d='M7.5,10 C8.88,10 10,8.88 10,7.5 C10,6.12 8.88,5 7.5,5 C6.12,5 5,6.12 5,7.5 C5,8.88 6.12,10 7.5,10 Z' />
            <path d='M15,7.71428571 C15,14.1428571 8.75,18 7.5,18 C6.25,18 0,14.1428571 0,7.71428571 C0,3.45471429 3.35875,0 7.5,0 C11.64125,0 15,3.45471429 15,7.71428571 Z' />
          </g>
        </g>
      </g>
    </svg>
  )
}

LocationIcon.propTypes = {
  height: PropTypes.string,
  style: PropTypes.object,
  colour: PropTypes.string,
  lineWeight: PropTypes.number
}

LocationIcon.defaultProps = {
  height: Sizes(0),
  colour: Colours('grey', '500'),
  lineWeight: 1
}

export default LocationIcon
